"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderActions = void 0;
var HeaderActions_1 = require("./HeaderActions");
Object.defineProperty(exports, "HeaderActions", { enumerable: true, get: function () { return __importDefault(HeaderActions_1).default; } });
